import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Save = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 19H5C4.46667 19 4 18.5333 4 18V8.33333C4 7.8 4.2 7.26667 4.6 6.93333L6.93333 4.6C7.33333 4.2 7.8 4 8.33333 4H18C18.5333 4 19 4.46667 19 5V18C19 18.6 18.6 19 18 19Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 4V8C9 8.53333 9.46667 9 10 9H15C15.5333 9 16 8.53333 16 8V4"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9996 12H7.99963C7.4663 12 6.99963 12.4667 6.99963 13V19H15.9996V13C15.9996 12.4667 15.5996 12 14.9996 12Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
